module.exports = __webpack_public_path__ + "img/c-thermometer-img3-2.373af1a9.png";